import * as React from 'react';

import MetricsBar from 'components/metrics-bar/MetricsBar';

import { __t, applyTranslations } from 'utils/language';
import { prepareMetrics } from './utils/mappings';

import type { BudgetSplitResourceV2 } from 'modules/reporting/types/BudgetSplitResource.type';
import type { CustomReportOffer } from 'modules/campaigns/types/CampaignCustomReport.type';

import './report-download-metrics-summary.scss';

applyTranslations(require('./report-download-metrics-summary.i18n.json'));

type Props = {
  splits: Array<BudgetSplitResourceV2>,
  groupedDeliverables: Array<CustomReportOffer>,
  checkedIds: Array<number>
};
const ReportDownloadMetricsSummary = React.memo<Props>((
  {
    splits,
    groupedDeliverables,
    checkedIds
  }: Props
): JSX.Element => (
  <section className="report-download-metrics-summary">
    <span className="report-download-metrics-summary__title">
      {__t('report_download_metrics_summary.main_label')}
    </span>
    <MetricsBar
      isMonochrome
      metrics={prepareMetrics(splits, groupedDeliverables, checkedIds)}
    />
  </section>
));

export default ReportDownloadMetricsSummary;
